import React from "react";
import { Button, Result } from "antd";
import { useHistory } from "react-router-dom";
import { getValidLandingScreen } from "../../helpers/utils";

const NotFound = () => {
  const history = useHistory();
  return (
    <Result
      status="404"
      title=""
      subTitle="Sorry, the page you visited does not exist."
      extra={
        <Button
          type="primary"
          onClick={() => history.push(getValidLandingScreen())}
        >
          Back Home
        </Button>
      }
    />
  );
};
export default NotFound;
